module.exports = __webpack_public_path__ + "img/nabteb.85463660.png";